<template>
  <div class="endetjqlc">
    <subTitle text="处理案件接洽流程" />
    <div class="jqlclist">
      <div class="jqitem flex_start">
        <div class="jqlcicon">
          <img src="~assets/entrust/ajjqlcicon1.png" alt="" />
        </div>
        <div class="jqlcwz ellipsis">查看接洽律师的回复</div>
      </div>

      <div class="jqitem flex_start">
        <div class="jqlcicon">
          <img src="~assets/entrust/ajjqlcicon2.png" alt="" />
        </div>
        <div class="jqlcwz ellipsis">从回复中挑选律师进行电话详谈</div>
      </div>

      <div class="jqitem flex_start">
        <div class="jqlcicon">
          <img src="~assets/entrust/ajjqlcicon3.png" alt="" />
        </div>
        <div class="jqlcwz ellipsis">关闭委托</div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.endetjqlc {
  padding: 20px;
  .jqlclist {
    .jqitem {
      margin-top: 20px;
      font-size: 14px;
      color: #666666;
      .jqlcicon {
        margin-right: 18px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
      .jqlcwz {
        width: 230px;
      }
    }
  }
}
</style>